import { InjectionToken } from '@angular/core';

export interface ZonePayConfig {
  enableCustomPaymentAmount: boolean;
}

export const ZONE_PAY_CONFIG = new InjectionToken<ZonePayConfig>(
  'ZONE_PAY_CONFIG',
);

export function provideZonePayConfig(config: ZonePayConfig) {
  return {
    provide: ZONE_PAY_CONFIG,
    useValue: config,
  };
}
